import React, {useCallback, useEffect, useState} from "react"
import {Col, Form, message, Modal, Result, Row, Skeleton, Switch} from "antd"
import {fetchTableList, updateEnableTable} from "../../../../../api/groupon"
import {useGroupBuyingContext} from "../../../store/useGroupBuyingContext"


const GroupBuyingEditTable = ({enabledTables, isEnabledOnAllTables, grouponId}) => {

    const {grouponListState} = useGroupBuyingContext()

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errMsg, setErrMsg] = useState(false)
    const [tableOption, setTableOption] = useState([])
    const [isAllTable, setIsAllTable] = useState(true)
    const [enabledTableIds, setEnabledTableIds] = useState(enabledTables.map(table => table.id))

    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue({tableList: enabledTableIds})
    }, [enabledTableIds, form])

    const handleSwitchChange = (checked, itemId) => {
        if (checked) {
            setEnabledTableIds(prev => [...prev, itemId])
        } else {
            setEnabledTableIds(prev => prev.filter(id => id !== itemId))
        }
    }
    const getTableList = useCallback(async () => {
        await fetchTableList().then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
                return
            }
            const options = res.data.map(item => {
                return {
                    label: item.name,
                    value: item.id,
                }
            })
            setTableOption(options)
        }).catch(err => {
            setIsError(true)
            setErrMsg(err.message)
        })
    }, [tableOption])

    const handleClick = async () => {
        form.resetFields()
        setIsShow(true)
        setIsLoading(true)
        setIsAllTable(isEnabledOnAllTables)
        form.setFieldValue('isAllTable', isEnabledOnAllTables)
        await getTableList().finally(() => {
            setIsLoading(false)
        })
    }

    const handleFinish = async () => {
        const params = {
            grouponIds: [grouponId],
            isEnabledOnAllTables: isAllTable,
            enabledTableIds: isAllTable ? null : form.getFieldValue('tableList')
        }
        await updateEnableTable(params).then(res => {
            if (res.status !== 1) {
                message.error(`更新球台信息失败：${res.detail}`)
                return
            }
            message.success("更新球台信息成功")
            setIsShow(false)
            grouponListState.reFetch()
        }).catch(err => {
            message.error(`更新球台信息失败：${err}`)
        })
    }


    return (
        <div>
            <span onClick={handleClick}>编辑可用球台</span>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={form.submit}
                width={800}
            >
                {isError ? <Result title={"获取球台信息发生错误"} subTitle={errMsg}/> :
                    <Skeleton loading={isLoading} active>
                        <Form
                            form={form}
                            onFinish={handleFinish}
                        >
                            <Form.Item
                                label={"是否全球台通用"}
                                valuePropName={"checked"}
                                name="isAllTable"
                            >
                                <Switch
                                    checkedChildren="是"
                                    unCheckedChildren="否"
                                    onChange={(checked) => {
                                        setIsAllTable(checked)
                                    }}
                                />
                            </Form.Item>
                            {isAllTable ? null : <div>
                                <Form.Item
                                    label={"选择球台"}
                                    name="tableList"
                                >
                                    <Row>
                                        {tableOption.map((item) => (
                                            <Col span={6}>
                                                <Switch
                                                    checked={enabledTableIds.includes(item.value)}
                                                    style={{marginTop: 10}}
                                                    checkedChildren={item.label}
                                                    unCheckedChildren={item.label}
                                                    onChange={(checked) => handleSwitchChange(checked, item.value)}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </Form.Item>
                            </div>}
                        </Form>
                    </Skeleton>}
            </Modal>
        </div>
    )
}

export default GroupBuyingEditTable


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingEdit/component/GroupBuyingEditTable.js